<template>
  <div>
    <ResourceDetail
      v-if="pageStatus === 'resourceDetail'"
      :toDetailData="toDetailData"
      @changeToLeader="changeToLeader()"
    ></ResourceDetail>
    <ResourceLeader
      v-if="pageStatus === 'leader'"
      :toLedgerData="toLedgerData"
      @changeToDetail="changeToDetail"
    ></ResourceLeader>
  </div>
</template>
<script>
import ResourceDetail from "./resourceDetail/ResourceDetail";
import ResourceLeader from "./resourceLeader/ResourceLeader";
export default {
  name: "Resources",
  components: {
    ResourceDetail,
    ResourceLeader,
  },
  data() {
    return {
      pageStatus: "leader",
      toDetailData: {},
      toLedgerData: {
        page: 1,
        pageSize: 10,
        querySubmitTime: undefined,
        queryHousingResId: undefined,
        queryHousingResName: undefined,
        queryHousingResAddress: undefined,
        queryObligeeName: undefined,
      },
    };
  },
  methods: {
    changeToLeader() {
      this.pageStatus = "leader";
    },
    changeToDetail(val) {
      this.toLedgerData.page = val.page;
      this.toLedgerData.pageSize = val.pageSize;
      this.toLedgerData.querySubmitTime = val.querySubmitTime;
      this.toLedgerData.queryHousingResId = val.queryHousingResId;
      this.toLedgerData.queryHousingResName = val.queryHousingResName;
      this.toLedgerData.queryHousingResAddress = val.queryHousingResAddress;
      this.toLedgerData.queryObligeeName = val.queryObligeeName;
      this.toDetailData = {
        webId: val.webId,
        isEditable: val.isEditable,
        createType: val.createType,
        selectRightList: val.selectRightList,
      };
      this.pageStatus = "resourceDetail";
    },
  },
};
</script>

<style>
</style>